<template>
    <div class="server_content">
        <div class="list_item" v-for="(item, index) in NavbarList" :key="index">
            <div class="img_box">
                <img src="../../assets/static/index/mbg.png" alt="">
                <span>{{ item.title }}</span>
            </div>
            <div class="list_box">
                <div class="child_item" v-for="(child, inx) in item.navList" :key="inx" @click="showDetail(child, inx )">
                    <span class="iconfont icon-jiantou-copy"></span>
                    <span class="c_name">{{ child.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Qs from "qs"
    export default {
        data() {
            return {
                list: [
                    {
                        title:"党群服务",
                        children: [
                            { name: "通知公告" },
                            { name: "消息提醒" },
                            { name: "党建地图" },
                            { name: "党费缴纳" },
                            { name: "书记信箱" },
                            { name: "我要入党" },
                            { name: "官方网站" },
                            { name: "组织转接" },
                            { name: "组织积分榜" },
                            { name: "个人积分榜" },
                        ]
                    },
                    {
                        title:"红色学堂",
                        children: [
                            { name: "我的学分" },
                            { name: "我的课程" },
                            { name: "我的考试" },
                            { name: "学习记录" },
                            { name: "考试测评" },
                            { name: "红色学堂" }
                        ]
                    },
                    {
                        title:"组织生活",
                        children: [
                            { name: "三会一课" },
                            { name: "主题当日" },
                            { name: "民主生活会" },
                            { name: "组织生活会" },
                            { name: "谈心谈话" },
                            { name: "中心组学习会" },
                            { name: "投票活动" },
                            { name: "民主评议" },
                            { name: "党员先锋展" },
                            { name: "志愿活动" },
                            { name: "其他会议"}
                        ]
                    },
                    {
                        title:"党群宣传",
                        children: [
                            { name: "党建要闻" },
                            { name: "党建动态" },
                            { name: "党的建设" },
                            { name: "上级精神" },
                            { name: "政策解读" },
                            { name: "文明创建" },
                            { name: "支部风采" },
                            { name: "共产党员风采" },
                            { name: "法规制度" },
                            { name: "资料下载" },
                        ]
                    },
                    {
                        title:"党务知识",
                        children: [
                            { name: "党的纪律" },
                            { name: "党务问答" },
                            { name: "党的组织" },
                            { name: "入党知识" },
                            { name: "党章党规" },
                            { name: "党费相关" },
                            { name: "党内监督" },
                            { name: "政治生活" },
                            
                        ]
                    },
                    {
                        title:"便民服务",
                        children: [
                            { name: "公积金查询" },
                            { name: "社保查询" },
                            { name: "万年历" },
                            { name: "违章查询" },
                            { name: "限行查询" },
                            { name: "空气质量" },
                            { name: "快递查询" },
                            { name: "郑州地铁" },
                            { name: "天气查询" }
                        ]
                    },
                ],
                NavbarList:[
                    {
                        title: "党建新闻",
                        navList:[
                            { name: "党建要闻", cate_id: "1" },{ name: "纪律建设", cate_id: "201"},{ name: "政策解读", cate_id: "186"},
                            { name: "反腐倡廉", cate_id: "187"},{ name: "领导讲话", cate_id: "178"},{ name: "党章党规", cate_id: "7"},
                        ]
                    },
                    {
                        title: "党的建设",
                        navList:[
                            // { name: "支部风采", cate_id: "189"},{ name: "理论前沿", cate_id: "195"},
                            // { name: "学习强国", cate_id: "197"},{ name: "先进支部", cate_id: "17"},{ name: "支部动态", cate_id: "200"},
                        ]
                    },
                    {
                        title: "组织生活",
                        navList:[
                            { name: "主题党日", path: "/MeetingShow/meeting/0?meetingType=1&buildingPartyType=1&title=主题党日&activeMain=1&activeChild=0" },
                            { name: "谈心谈话", path: "/MeetingShow/meeting/0?meetingType=5&buildingPartyType=2title%3D谈心谈话&activeMain=1&activeChild=4" },
                            { name: "投票活动", path: "/MeetingShow/toupiao?activeMain=1&activeChild=5"},
                            { name: "民主评议", path: "/MeetingShow/mzpy?activeMain=1&activeChild=6" },
                            { name: "志愿活动", path: "/MeetingShow/zhiyuan?activeMain=1&activeChild=7" },
                        ]
                    },
                ],
                SixArray:[],
            }
        },
        created() {
            this.getSix()
        },
        methods: {
            // 去新闻分类页
            showDetail ( item, index ) {
                if ( item.cate_id ) {
                    this.$router.push({
                        path: "/moreNewsList",
                        query: {
                            cate_id: item.cate_id,
                            keyword: "",
                            isSearch: 0
                        }
                    })
                } else if ( item.path ) {
                    this.$router.push( item.path )
                }
            },
            // 获取六大建设
            async getSix() {
                
                let res = await this.$axios.post("/lencon/pc/news/allCates", Qs.stringify({ cateId: 1 }))
                console.log( res )
                if ( res.data.code == 1 ) {
                    this.SixArray = res.data.newsCateList
                    let arr = this.NavbarList[1].navList
                    this.SixArray.forEach( (el, index ) => {
                        // arr[index].name = el.sCateName
                        // arr[index].cate_id = el.sCateId
                        arr.push({
                            name:el.sCateName,
                            cate_id: el.sCateId
                        })
                    })
                    this.NavbarList[1].navList = arr
                    console.log(arr)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.server_content {
    width: 1200px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .list_item {
        width: 300px;
        margin: 20px 0;
        border-radius: 5px;
        overflow: hidden;
        .img_box {
            width: 300px;
            position: relative;
            left: 0;
            top: 0;
            img {
                width: 300px;
                height: 130px;
            }
            span {
                position: absolute;
                width: 100%;
                left: 0;
                top: 0;
                text-align: center;
                line-height: 130px;
                font-size: 30px;
                font-weight: bold;
                color: #fff;
            }
        }
        .list_box {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            .child_item {
                width: 130px;
                margin: 10px;
                cursor: pointer;
                .iconfont {
                    font-size: 10px;
                    color: #B0AFAF;
                }
                .c_name {
                    font-size: 16px;
                    margin-left: 10px;
                }
            }
        }
        
    }
}
</style>